// extracted by mini-css-extract-plugin
export default {"socialProof":"socialProof__ZjIyO","dek":"dek__Yzg5Z","tooltipContainer":"tooltipContainer__Y2I5N","tooltipIcon":"tooltipIcon__ZThhM"};